var base = require('settings/teams/create-team');

Vue.component('spark-create-team', {
  mixins: [base],
  props: ['show'],
  methods: {
    createInModal() {
      this.create();
      this.goBack();
    },
    goBack() {
      this.$emit('close');
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/teams/create-team.js